module.exports = __webpack_public_path__ + "img/bot2.de78b040.svg";